// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-article-link {
    position: relative;
    display: inline-block;
    vertical-align: -0.125em;
    line-height: 1;
}

.hal-trigger {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    outline: none;
}

.hal-trigger:focus-visible .hal-icon,
.hal-trigger:focus-visible .hal-badge {
    outline: 2px solid #316C29;
    outline-offset: 2px;
}

/* Icon — indigo circle with ? */
.hal-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #316C29;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    font-style: normal;
    font-family: sans-serif;
    line-height: 1;
    flex-shrink: 0;
    transition: background-color 0.15s;
    user-select: none;
}

.hal-trigger:hover .hal-icon {
    background-color: #1D2E23;
}

/* Label for link variant */
.hal-label {
    font-size: 0.875em;
    color: var(--color-link, #316C29);
    text-decoration: underline;
    text-underline-offset: 2px;
    transition: color 0.15s;
}

.hal-trigger:hover .hal-label {
    color: var(--color-link-hover, #1D2E23);
}

/* Badge variant */
.hal-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 9px;
    border-radius: 999px;
    background-color: #e4f1e7;
    color: #316C29;
    font-size: 0.75rem;
    font-weight: 500;
    border: 1px solid #B4CCC6;
    line-height: 1.5;
    transition: background-color 0.15s;
    white-space: nowrap;
}

.hal-trigger:hover .hal-badge {
    background-color: #B4CCC6;
    color: #1D2E23;
}

/* Popover panel */
.hal-popover {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    z-index: 1000;
    width: 300px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    /* Prevent parent text-level styles bleeding in */
    font-size: 14px;
    font-weight: 400;
    color: #1f2937;
    text-align: left;
    font-style: normal;
}

.hal-popover__state {
    display: block;
    padding: 11px 14px;
    font-size: 0.825rem;
    color: #6b7280;
    font-style: italic;
}

.hal-popover__state--error {
    color: #dc2626;
}

/* Article card */
.hal-card {
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 10px 14px;
    border-bottom: 1px solid #f3f4f6;
    text-decoration: none;
    color: inherit;
    transition: background-color 0.1s;
    cursor: pointer;
}

.hal-card:last-child {
    border-bottom: none;
}

.hal-card:hover {
    background-color: #f8fafc;
}

.hal-card__category {
    font-size: 0.68rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #316C29;
    line-height: 1;
}

.hal-card__title {
    font-size: 0.85rem;
    font-weight: 600;
    color: #1f2937;
    line-height: 1.3;
    transition: color 0.1s;
}

.hal-card:hover .hal-card__title {
    color: #316C29;
}

.hal-card__excerpt {
    font-size: 0.775rem;
    color: #6b7280;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
[data-theme="dark"] .hal-popover {
    background: #1c2620;
    border-color: #3a463e;
    color: #e3ece6;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.3);
}
[data-theme="dark"] .hal-popover__state { color: #9fb0a6; }
[data-theme="dark"] .hal-popover__state--error { color: #ff8a94; }
[data-theme="dark"] .hal-card { border-bottom-color: #2c3a33; }
[data-theme="dark"] .hal-card:hover { background-color: #222f28; }
[data-theme="dark"] .hal-card__title { color: #e3ece6; }
[data-theme="dark"] .hal-card__excerpt { color: #9fb0a6; }
[data-theme="dark"] .hal-badge { background-color: #223129; color: #8fd66c; border-color: #3a463e; }
[data-theme="dark"] .hal-trigger:hover .hal-badge { background-color: #2c3a33; color: #b9e79c; }
`, "",{"version":3,"sources":["webpack://./src/components/Seller/HelpArticleLink.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA;;IAEI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,iCAAiC;IACjC,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,kBAAkB;AAClB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,yEAAyE;IACzE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iDAAiD;IACjD,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;IAChC,qBAAqB;IACrB,cAAc;IACd,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,uEAAuE;AAC3E;AACA,0CAA0C,cAAc,EAAE;AAC1D,iDAAiD,cAAc,EAAE;AACjE,gCAAgC,4BAA4B,EAAE;AAC9D,sCAAsC,yBAAyB,EAAE;AACjE,uCAAuC,cAAc,EAAE;AACvD,yCAAyC,cAAc,EAAE;AACzD,iCAAiC,yBAAyB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACnG,oDAAoD,yBAAyB,EAAE,cAAc,EAAE","sourcesContent":[".help-article-link {\n    position: relative;\n    display: inline-block;\n    vertical-align: -0.125em;\n    line-height: 1;\n}\n\n.hal-trigger {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    text-decoration: none;\n    color: inherit;\n    cursor: pointer;\n    outline: none;\n}\n\n.hal-trigger:focus-visible .hal-icon,\n.hal-trigger:focus-visible .hal-badge {\n    outline: 2px solid #316C29;\n    outline-offset: 2px;\n}\n\n/* Icon — indigo circle with ? */\n.hal-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background-color: #316C29;\n    color: #fff;\n    font-size: 10px;\n    font-weight: 700;\n    font-style: normal;\n    font-family: sans-serif;\n    line-height: 1;\n    flex-shrink: 0;\n    transition: background-color 0.15s;\n    user-select: none;\n}\n\n.hal-trigger:hover .hal-icon {\n    background-color: #1D2E23;\n}\n\n/* Label for link variant */\n.hal-label {\n    font-size: 0.875em;\n    color: var(--color-link, #316C29);\n    text-decoration: underline;\n    text-underline-offset: 2px;\n    transition: color 0.15s;\n}\n\n.hal-trigger:hover .hal-label {\n    color: var(--color-link-hover, #1D2E23);\n}\n\n/* Badge variant */\n.hal-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 9px;\n    border-radius: 999px;\n    background-color: #e4f1e7;\n    color: #316C29;\n    font-size: 0.75rem;\n    font-weight: 500;\n    border: 1px solid #B4CCC6;\n    line-height: 1.5;\n    transition: background-color 0.15s;\n    white-space: nowrap;\n}\n\n.hal-trigger:hover .hal-badge {\n    background-color: #B4CCC6;\n    color: #1D2E23;\n}\n\n/* Popover panel */\n.hal-popover {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    z-index: 1000;\n    width: 300px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    /* Prevent parent text-level styles bleeding in */\n    font-size: 14px;\n    font-weight: 400;\n    color: #1f2937;\n    text-align: left;\n    font-style: normal;\n}\n\n.hal-popover__state {\n    display: block;\n    padding: 11px 14px;\n    font-size: 0.825rem;\n    color: #6b7280;\n    font-style: italic;\n}\n\n.hal-popover__state--error {\n    color: #dc2626;\n}\n\n/* Article card */\n.hal-card {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    padding: 10px 14px;\n    border-bottom: 1px solid #f3f4f6;\n    text-decoration: none;\n    color: inherit;\n    transition: background-color 0.1s;\n    cursor: pointer;\n}\n\n.hal-card:last-child {\n    border-bottom: none;\n}\n\n.hal-card:hover {\n    background-color: #f8fafc;\n}\n\n.hal-card__category {\n    font-size: 0.68rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: #316C29;\n    line-height: 1;\n}\n\n.hal-card__title {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: #1f2937;\n    line-height: 1.3;\n    transition: color 0.1s;\n}\n\n.hal-card:hover .hal-card__title {\n    color: #316C29;\n}\n\n.hal-card__excerpt {\n    font-size: 0.775rem;\n    color: #6b7280;\n    line-height: 1.4;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n[data-theme=\"dark\"] .hal-popover {\n    background: #1c2620;\n    border-color: #3a463e;\n    color: #e3ece6;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n[data-theme=\"dark\"] .hal-popover__state { color: #9fb0a6; }\n[data-theme=\"dark\"] .hal-popover__state--error { color: #ff8a94; }\n[data-theme=\"dark\"] .hal-card { border-bottom-color: #2c3a33; }\n[data-theme=\"dark\"] .hal-card:hover { background-color: #222f28; }\n[data-theme=\"dark\"] .hal-card__title { color: #e3ece6; }\n[data-theme=\"dark\"] .hal-card__excerpt { color: #9fb0a6; }\n[data-theme=\"dark\"] .hal-badge { background-color: #223129; color: #8fd66c; border-color: #3a463e; }\n[data-theme=\"dark\"] .hal-trigger:hover .hal-badge { background-color: #2c3a33; color: #b9e79c; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
